import { NodeSelection } from '@atlaskit/editor-prosemirror/state';
import { aiButtonPluginKey } from './ai-button-plugin-key';
import { SafePlugin } from '../local-safe-plugin';
export const createAIButtonPlugin = options => {
  const {
    dispatch
  } = options;
  return new SafePlugin({
    key: aiButtonPluginKey,
    state: {
      init: (_, state) => ({
        isSelectionValidForAIExperience: true
      }),
      apply: (tr, _pluginState, _oldEditorState, newEditorState) => {
        if (tr.selectionSet) {
          const selection = tr.selection;
          const {
            $from
          } = selection;
          const parent = $from.parent;
          const codeBlockType = newEditorState.schema.nodes.codeBlock.name;
          const isNodeSelection = selection instanceof NodeSelection;
          const isSelectionInCodeBlock = parent.type.name === codeBlockType;

          // We don't want to import CellSelection from @atlaskit/editor-tables
          //  in order to avoid dependency.
          // $anchorCell only exists in CellSelection.
          // So if it exists, then we can assume that, it is cell selection.
          // Not even import CellSelection as type in order to avoid
          //  dependency management when we are close to EAP.
          // TODO AIFOLLOWUP
          const isCellSelection = !!selection.$anchorCell;
          // AI button is always disabled for Node selection.
          // AI button is always disabled for Cell selection.
          // AI button is always disabled for selection in code block.
          // For all other selection and empty selections AI button is enabled.
          let isSelectionValidForAIExperience = true;
          if (isSelectionInCodeBlock || isNodeSelection || isCellSelection) {
            isSelectionValidForAIExperience = false;
          }
          const newPluginState = {
            isSelectionValidForAIExperience
          };

          // We need to dispatch state change
          // As we use WithPluginState to enable/disable AI button.
          dispatch(aiButtonPluginKey, newPluginState);
          return newPluginState;
        }
        return _pluginState;
      }
    }
  });
};